import { Module } from "vuex";
import RootState from "./root-state";
import ProjectManager from "@/entities/project-manager";
import ProjectWorker from "@/entities/project-worker";
import ProjectWorkerApi from "@/api/gateways/project-worker-api";
import ProjectManagerApi from "@/api/gateways/project-manager-api";
import ProjectMember from "@/entities/project-member";
import { ProjectId } from "@/entities/ids";

export default {
  namespaced: true,
  state: {
    managers: [],
    workers: []
  },
  getters: {
    ["all"](state) {
      return [
        ...state.managers.filter(m => m.assigned),
        ...state.workers.filter(m => m.assigned)
      ] as ProjectMember[];
    },
    ["assigned-managers"](state) {
      return state.managers.filter(m => m.assigned);
    },
    ["unassigned-managers"](state) {
      return state.managers.filter(m => !m.assigned);
    },
    ["assigned-workers"](state) {
      return state.workers.filter(m => m.assigned);
    },
    ["unassigned-workers"](state) {
      return state.workers.filter(m => !m.assigned);
    }
  },
  mutations: {
    ["load-managers"](state, managers) {
      state.managers = managers;
    },
    ["load-workers"](state, workers) {
      state.workers = workers;
    }
  },
  actions: {
    async ["load-all"]({ dispatch }, projectId) {
      dispatch("load-managers", projectId);
      dispatch("load-workers", projectId);
    },
    async ["load-managers"]({ commit, rootGetters }, projectId: ProjectId) {
      const gw = new ProjectManagerApi(rootGetters.api, projectId);
      commit("load-managers", await gw.all());
    },
    async ["load-workers"]({ commit, rootGetters }, projectId: ProjectId) {
      const gw = new ProjectWorkerApi(rootGetters.api, projectId);
      commit("load-workers", await gw.all());
    },
    async ["assign-manager"]({ rootGetters }, { id, projectId }) {
      const gw = new ProjectManagerApi(rootGetters.api, projectId);
      await gw.assign(id);
    },
    async ["unassign-manager"]({ rootGetters }, { id, projectId }) {
      const gw = new ProjectManagerApi(rootGetters.api, projectId);
      await gw.unassign(id);
    },
    async ["assign-worker"]({ rootGetters }, { id, projectId }) {
      const gw = new ProjectWorkerApi(rootGetters.api, projectId);
      await gw.assign(id);
    },
    async ["unassign-worker"]({ rootGetters }, { id, projectId }) {
      const gw = new ProjectWorkerApi(rootGetters.api, projectId);
      await gw.unassign(id);
    }
  }
} as Module<ProjectMemberState, RootState>;

export interface ProjectMemberState {
  managers: ProjectManager[];
  workers: ProjectWorker[];
}
